import { SelectedFilterInterface, SelectedFiltersInterface } from '@project/interfaces/ISearchPage';
import React, { createContext, useState, ReactNode, useContext } from 'react';

// Define the type for the context value
interface SearchSidebarContextType {
  showSearchBar: boolean;
  selectedFilter?: SelectedFilterInterface;
  selectedFilters?: SelectedFiltersInterface;
  filterList?: {
    gradeLevels: any[];
    conceptZones: any[];
    resourceTypes: any[];
    concepts: any[];
  };
  setFilterList: React.Dispatch<React.SetStateAction<any | undefined>>;
  setSelectedFilters: React.Dispatch<React.SetStateAction<SelectedFiltersInterface | undefined>>;
  setShowSearchBar: React.Dispatch<React.SetStateAction<boolean>>;
}

// Create the context with an empty default value
export const SearchSidebarContext = createContext<SearchSidebarContextType | undefined>(undefined);

// Context provider component props
interface SearchSidebarProviderProps {
  children: ReactNode;
}

// Context provider component
export const SearchSidebarProvider = ({ children }: SearchSidebarProviderProps) => {
  const [showSearchBar, setShowSearchBar] = useState<boolean>(true);
  const [selectedFilters, setSelectedFilters] = useState<SelectedFiltersInterface | undefined>();
  const [filterList, setFilterList] = useState<any | undefined>({});

  return (
    <SearchSidebarContext.Provider
      value={{ selectedFilters, setSelectedFilters, showSearchBar, setShowSearchBar, filterList, setFilterList }}
    >
      {children}
    </SearchSidebarContext.Provider>
  );
};

// Custom hook to use the SearchSidebarContext (optional)
export const useSearchSidebarContext = (): SearchSidebarContextType => {
  const context = useContext(SearchSidebarContext);
  if (!context) {
    throw new Error('useSearchSidebarContext must be used within a SearchSidebarProvider');
  }
  return context;
};
